import styled from 'styled-components';
import {  MagstimColor } from "common";

const styledMagstimTableWrapper = styled.div`

.table-wrapper {

    .table-scroll {
        overflow: auto;
        margin-top: 34px; 
        height: ${props => props.tableHeight};

        table{
            margin-top:20px;
        }

        table thead tr th span {
            position:absolute; 
            display: block;
            padding-left:10px;
            padding-right:10px;
            margin-top:16px;
            margin-bottom:16px;
            vertical-align: middle;
        }
        table thead tr th:first-child span {
            height: 40px;
            background-color: ${ MagstimColor.MagstimSecondaryButton};

            div {
                padding-top: 0px;
            }
        }
        table thead tr th span {
            height: 40px;
            background-color: ${ MagstimColor.MagstimSecondaryButton};

            div {
                padding-top: 0px;
            }
        }
        table thead tr th span div {
            display: block;
            height: 30px;
            line-height: 30px;
            vertical-align: middle;
        }
        table thead tr th span i.fa-eye, table thead tr th span i.fa-eye-slash {
            display: block;
            height: 30px!important;
            line-height: 30px!important;
            vertical-align: middle;
        }
        table tbody tr td {
            padding-left: 10px;
            padding-right: 10px;
        }
    }
    .table-scroll::-webkit-scrollbar {
        width:20px; /*  manage scrollbar width here */
    }
    .table-scroll::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 0;
    }
    .table-scroll::-webkit-scrollbar-thumb {
        background-color: ${ MagstimColor.MagstimPrimaryBlue}; /* manage scrollbar thumb background color here */
        border-radius: 0;
    }	
}
`
export default styledMagstimTableWrapper;